<template>
  <div
    class="
      min-height
      user-list-main-wrapper
      cbg-white-container
      theme--light
      v-card
      user-list-wrap-box
    "
  >
    <loader v-if="isLoader"></loader>
    <CCol sm="12">
      <CCol sm="12" class="pl-0 pr-0">
        <CRow>
          <CCol sm="6" md="3">
            <div class="position-relative">
              <label for>Select Center type</label>
              <select v-model="filters.center_type" class="form-control" @change="getStaffList()">
                <option value="all">All</option>
                <option value="ambulance">Ambulance</option>
                <option value="bloodbank">Blood Bank</option>
                <option value="diagnostics-lab">Diagnostics</option>
                <option value="pharmacy">Pharmacy</option>
              </select>
              <span class="drop-icon">
                <i
                  aria-hidden="true"
                  class="
                    v-icon
                    mdi mdi-menu-down
                    theme--light
                    position-absolute
                  "
                ></i>
              </span>
            </div>
          </CCol>

          <CCol sm="6" md="3">
            <div class="position-relative">
              <label for>Filter by status</label>
              <select v-model="filters.status" class="form-control" @change="getStaffList()">
                <option
                  v-for="(option, i) in statusOptions"
                  :key="i"
                  :value="option.value"
                >
                  {{ option.name }}
                </option>
              </select>
              <span class="drop-icon">
                <i
                  aria-hidden="true"
                  class="
                    v-icon
                    mdi mdi-menu-down
                    theme--light
                    position-absolute
                  "
                ></i>
              </span>
            </div>
          </CCol>

          <!-- this filter for active user page end -->
        </CRow>
      </CCol>
      <CCol sm="12" class="pl-0 pr-0">
        <div class="overflow-auto">
          <!-- changes done by durgesh on 21-1-2022 -->
          <table class="table userlistTable table-width">
            <thead>
              <tr class="table-success">
                <!-- 0 -->
                <th scope="col" class="min-width-120">Staff Name</th>
                <!-- 1 -->
                <th scope="col">Age</th>
                <!-- 2 -->
                <th scope="col">Gender</th>
                <!-- 3 -->
                <th scope="col">Mobile Number</th>
                <!--  4-->
                <th scope="col" class="min-width-130">UserID</th>
                <!-- 5 -->
                <th scope="col" class="min-width-130">Owner Name</th>
                <!--6-->
                <th scope="col">Action</th>
              </tr>
            </thead>

            <tbody v-if="!isEmpty">
              <tr>
                <!-- staff Name -->
                <td class="position-relative search-div table-div">
                  <input
                    class="form-control"
                    label="Search"
                    placeholder="Name"
                    v-model="filters.staff_name" 
                    @keyup="debounceSearch()"
                  />
                  <div
                    v-if="filters.staff_name !== ''"
                    class="search-svg cursor position-absolute"
                    @click="filters.staff_name = '',debounceSearch()"
                  >
                    <crossSVG />
                  </div>
                </td>
                <!-- Age -->
                <td></td>
                <!-- Gender -->
                <td class="position-relative min-width-120"></td>

                <!-- Mobile Number -->
                <td>
                  <input v-model="filters.mobile"  placeholder="Mobile Number" class="form-control" @keyup="debounceSearch()"/>
                  <div
                    v-if="filters.mobile !== ''"
                    class="search-svg cursor position-absolute"
                    @click="filters.mobile = '',debounceSearch()"
                  >
                    <crossSVG />
                  </div>
                </td>

                <!-- User ID -->
                <td>
                  <input v-model="filters.userId" placeholder="User Id" class="form-control" @keyup="debounceSearch()"/>
                  <div
                    v-if="filters.userId !== ''"
                    class="search-svg cursor position-absolute"
                    @click="filters.userId = '',debounceSearch()"
                  >
                    <crossSVG />
                  </div>
                </td>

                <!-- owner anem -->
                <td>
                  <input v-model="filters.owner_name" placeholder="Owner Name" class="form-control" @keyup="debounceSearch()"/>
                  <div
                    v-if="filters.owner_name !== ''"
                    class="search-svg cursor position-absolute"
                    @click="filters.owner_name = '',debounceSearch()"
                  >
                    <crossSVG />
                  </div>
                </td>
              </tr>
            </tbody>

            <tbody v-if="!isEmpty">
              <tr v-for="(list, i) in staffList" :key="i">
                <!-- staff Name -->
                <td>
                  {{
                    list.staff_details.first_name +
                    " " +
                    list.staff_details.last_name
                  }}
                </td>
                <!-- Age -->
                <td>
                  {{ age(list.staff_details) }}
                </td>
                <!-- Gender -->
                <td>
                  <!-- Saili Rawanang -->
                  {{ list.staff_details.gender }}
                </td>

                <!-- Mobile Number -->
                <td>
                  {{ list.staff_details.mobile }}
                </td>

                <!-- User ID -->
                <td>
                  {{ list.user_id }}
                </td>

                <!-- owner anem -->
                <td>
                  {{
                    list.owner_details.first_name +
                    " " +
                    list.owner_details.last_name
                  }}
                </td>

                <!-- center assigned -->
                <td class="action-div small-table-padding">
                  <div>
                    <CDropdown
                      color="link"
                      size="lg"
                      :caret="false"
                      class="dropdowndocbox dropaddbox"
                    >
                      <template #toggler-content>
                        <verticalDotsSVG />
                      </template>
                      <CDropdownItem @click="showStaffDetails(list.centers)"
                        >Centres Assigned</CDropdownItem
                      >
                    </CDropdown>
                  </div>
                </td>
              </tr>
            </tbody>

            <tbody v-if="isEmpty">
              <tr>
                <td colspan="10">
                  <h2 class="text-center">No Data Found</h2>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </CCol>
      <pagination
        v-if="!isEmpty"
        class="mx-4 mob-t-center pagination-block"
        :recordPerPage="record_per_page"
        :total="total"
        @changePage="changePage"
      />
    </CCol>
    <v-dialog
      v-if="showStaff"
      v-model="showStaff"
      persistent
      scrollable
      content-class="staff-modal"
    >
      <staff-details v-if="showStaff" @close="showStaff = false" :centers="centers" />
    </v-dialog>
  </div>
</template> 
<script>
import config from "@/config.js";
import { pickSvg } from "@/views/SVG";
import debounce from "lodash/debounce";
import dayjs from "dayjs";
export default {
  props: {},
  data() {
    return {
      showStaff: false,
      statusOptions: [
        { name: "All", value: "all" },
        { name: "Active", value: "ACTIVE" },
        { name: "Inactive", value: "INACTIVE" },
      ],
      filters: {
        center_type: "all",
        status: "all",
        userId: "",
        mobile: "",
        staff_name: "",
        owner_name: "",
      },
      centers:[],
      currentPage: 1,
      record_per_page: 10,
      staffList: [],
      isEmpty: false,
      total: 0,
    };
  },
  computed: {
    isLoader() {
      return this.$store.state.general.isLoader;
    },
  },
  components: {
    ...pickSvg(
      "verticalDotsSVG",
      "crossSVG "
    ),
    loader: () => import("@/components/loader.vue"),
    staffDetails: () => import("@/components/modals/Staff/staffDetails.vue"),
    pagination: () => import("@/views/common/Pagination"),
  },
  mounted() {
    this.changePage(null, true);
  },
  methods: {
    age(data) {
      let date= data.dob && data.dob != null ? data.dob : data.estimated_dob
      return dayjs(new Date() ).diff(date,'year')
    },
    debounceSearch: debounce(function () {
      this.getStaffList();
    }, 800),
    changePage(page = { currentPage: 1, reduced: false }, reset = false) {
      if (reset) {
        page = { currentPage: 1, reduced: false };
      }
      if (!page.reduced) {
        this.currentPage = page.currentPage;
        this.getStaffList();
      } else {
        this.currentPage = 1;
        this.$forceUpdate();
      }
    },
    showStaffDetails(data) {
      this.showStaff = true;
      this.centers = data
    },
    getStaffList() {
     
      let url = `${config.BASE_URL}api/v2/admin/staffList`;
      let params = this.filters;
      params.page=this.currentPage;
      params.record_per_page=this.record_per_page;
      this.$http.get(url, { params }).then((res) => {
        if (res.status) {
          this.$store.commit("general/setLoader", false);
          if (res && res.data && res.data.data && res.data.data.list.length) {
            this.staffList = res.data.data.list;
            this.isEmpty = false;
          } else {
            this.staffList = [];
            this.isEmpty = true;
          }
          this.currentPage = res.data.data.page;
          this.dateRangeActive = false;
          this.total = res.data.data.count;
        } else {
          this.$store.commit("general/setLoader", false);
          this.staffList = [];
          this.isEmpty = true;
        }
      });
    },
  },
};
</script>
<style lang="scss">
.capitalize-text {
  text-transform: capitalize;
}

.profilebox svg {
  width: 15px !important;
}
</style>
